var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingListBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "memo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.25 14.5L7.25 14.5C6.83562 14.5 6.5 14.7812 6.5 15.125C6.5 15.4687 6.83562 15.75 7.25 15.75L13.25 15.75C13.6643 15.75 14 15.4702 14 15.125C14 14.7798 13.6625 14.5 13.25 14.5ZM17.75 10.75L7.25 10.75C6.83562 10.75 6.5 11.0312 6.5 11.375C6.5 11.7187 6.83562 12 7.25 12L17.75 12C18.1625 12 18.5 11.7187 18.5 11.375C18.5 11.0312 18.1625 10.75 17.75 10.75ZM17.75 7L7.25 7C6.83562 7 6.5 7.28125 6.5 7.625C6.5 7.96875 6.83562 8.25 7.25 8.25L17.75 8.25C18.1625 8.25 18.5 7.96875 18.5 7.625C18.5 7.28125 18.1625 7 17.75 7ZM18.5 2L6.5 2C4.84297 2 3.5 3.11914 3.5 4.5L3.5 19.5C3.5 20.8809 4.84297 22 6.5 22L18.5 22C20.157 22 21.5 20.8809 21.5 19.5L21.5 4.5C21.5 3.11914 20.1547 2 18.5 2ZM20 19.5C20 20.1891 19.3269 20.75 18.5 20.75L6.5 20.75C5.67313 20.75 5 20.1891 5 19.5L5 4.5C5 3.81094 5.67313 3.25 6.5 3.25L18.5 3.25C19.3269 3.25 20 3.81094 20 4.5L20 19.5Z",
    fill: "#0D2E78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingListBlue);
export default __webpack_public_path__ + "static/media/shopping-list-blue.e1a1ab26cd4c548a5895fd13fe0f8b55.svg";
export { ForwardRef as ReactComponent };